import { CUSTOMER_CARE_EMAIL } from "../../resources/constants";

export default function InfoRejected() {
  return (
    <div className="mt-5 mx-auto container" style={{ maxWidth: "576px" }}>
      <div className="text-center">
        <h2 className="primary-title mb-3">KYC Verification rejected</h2>
        <p>Your information provided for KYC Verification has been rejected.</p>
        {CUSTOMER_CARE_EMAIL && (
          <p>
            For any issues or enquiries, you reach out to us at
            {` ${CUSTOMER_CARE_EMAIL}`}
          </p>
        )}
      </div>
    </div>
  );
}
